import React from "react";
import { styled } from "@mui/material/styles";
import SetMenu from "../../../../assets/images/order/setmenu.png";
import Salad from "../../../../assets/images/order/salad.png";
import { Avatar, Grid } from "@mui/material";

const items = [
  { title: "Chicken Salad", icon: Salad },
  { title: "Egg Vegetarian", icon: Salad },
  { title: "Tomato Recipi", icon: Salad },
  { title: "Healthy Salad", icon: Salad },
  { title: "Chunky Vegetable", icon: Salad },
  { title: "Chicken Salad", icon: Salad },
  { title: "Egg Vegetarian", icon: Salad },
  { title: "Tomato Recipi", icon: Salad },
  { title: "Healthy Salad", icon: Salad },
  { title: "Chunky Vegetable", icon: Salad },
];

const FlexDivColumn = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

const FlexDiv = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

const Dishes = ({ selectCategory }) => {
  const handleSelection = (value) => {
    selectCategory(value);
  };
  return (
    <div style={{ minWidth: 743 }}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        {items.map((item, index) => (
          <SingleCard item={item} handleSelection={handleSelection} />
        ))}
      </Grid>
    </div>
  );
};

const SingleCard = ({ item, handleSelection }) => (
  <div
    style={{
      background: "#FFF",
      width: 133.17,
      height: 108,
      borderRadius: 4,
      marginBottom: 20,
      cursor: "pointer",
      textAlign: "left",
      cursor: "pointer",
      fontFamily: `Poppins, sans-serif`,
      boxShadow: "rgba(17, 17, 26, 0.1) 0px 1px 0px",
    }}
    onClick={() => handleSelection(item.title)}
  >
    <Avatar
      sx={{
        width: "100%",
        height: 65,
        borderTopRightRadius: 4,
        borderTopLeftRadius: 4,
      }}
      variant="square"
      src={item.icon}
    />
    <div
      style={{
        paddingLeft: 10,
        fontWeight: 400,
        color: "#424242",
        fontSize: 13,
      }}
    >
      {item.title}
    </div>
    <div
      style={{
        paddingLeft: 10,
        fontWeight: 500,
        color: "#FF0000",
        fontSize: 12,
      }}
    >
      TK 250
    </div>
  </div>
);

export default Dishes;
